<template lang="pug">
	.asset-replace-container(v-if="showed && isAllowedToShow" :style="containerStyle")
		.asset-replace-btn
			i.fa.fa-upload
		.asset-replace-hint Double-click to replace image
</template>

<script>
	import Screen from './../../mixins/screen';

	import { Version } from '../../services/Version';
	import { Elements } from '../../services/Elements';
	import { Asset } from '../../services/Asset';
	import { Layout } from '../../services/Layout';

	// Иконка-подсказка замены ассета по центру важной картинки (options.importantElement) при наведении на неё в превью.
	// Сама иконка не перехватывает мышь (pointer-events: none) - замена запускается двойным нажатием по элементу в iframe.
	export default {
		name: 'InlineAssetReplace',
		mixins: [Screen],
		screen: {
			events: {
				"IFrame Data:HitElement": function(data) {

					if (data && Elements.getImportantElement(data.screenCodename, data.elementCodename)?.type === 'image') this.showButton(data);
					else this.hideButton();

				},
				"IFrame Data:ReplaceImportantElementAsset": function(data) {

					this.replaceElementAsset(data.screenCodename, data.elementCodename);

				},
				"Preview Zoom Changed,Preview Drag State Changed,Preview Size Changed,Layout Workspace Changed,Aside State Changed,Sub Aside State Changed": function() {

					if (this.showed) {

						this.$nextTick(() => {
							this.updatePosition();
						});

					}

				},
				"Selected Version Switched": function() {

					this.hideButton();

				},
				"Selected Creative Changed,Refresh Iframe,IFrame Data:AppScreensCreated": function() {

					this.hideButton();

				},
				"Settings Tab Changed,Aside State Changed": function() {

					this.update();

				},
				"Element Changed: [options]": function() {

					if (this.showed && !Elements.getImportantElement(this.screenCodename, this.elementCodename)) this.hideButton();

				}
			}
		},
		data() {
			return {
				isAllowedToShow: false,
				screenCodename: null,
				elementCodename: null,
				lastIframeRelativeRect: null,
				position: {
					top: '0px',
					left: '0px'
				}
			};
		},
		computed: {
			containerStyle() {
				return {
					top: this.position.top,
					left: this.position.left
				};
			}
		},
		mounted() {

			this._onWindowResize = () => {

				if (this.showed) this.updatePosition();

			};

			window.addEventListener('resize', this._onWindowResize);

		},
		beforeDestroy() {

			if (this._onWindowResize) window.removeEventListener('resize', this._onWindowResize);

		},
		methods: {
			collectData() {

				this.isAllowedToShow = !(Layout.asideOpened && Layout.settingsTabName === 'elements');

			},
			showButton(data) {

				this.screenCodename = data.screenCodename;
				this.elementCodename = data.elementCodename;
				this.lastIframeRelativeRect = data.rect;

				this.show();

				this.$nextTick(() => {

					this.updatePosition(data.rect);

				});

			},
			hideButton() {

				this.hide();

			},
			updatePosition(iframeRelativeRect) {

				if (!iframeRelativeRect) iframeRelativeRect = this.lastIframeRelativeRect;
				if (!iframeRelativeRect) return;
				this.lastIframeRelativeRect = iframeRelativeRect;

				let iframe = document.querySelector('.preview-frame iframe') || document.querySelector('iframe');
				let iframeRect = iframe ? iframe.getBoundingClientRect() : { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };

				let baseWidth = (iframeRelativeRect.windowWidth && iframeRelativeRect.windowWidth > 0)
					? iframeRelativeRect.windowWidth
					: (iframe ? (iframe.offsetWidth || parseFloat(iframe.getAttribute('width')) || iframe.clientWidth || 0) : 0);

				let baseHeight = (iframeRelativeRect.windowHeight && iframeRelativeRect.windowHeight > 0)
					? iframeRelativeRect.windowHeight
					: (iframe ? (iframe.offsetHeight || parseFloat(iframe.getAttribute('height')) || iframe.clientHeight || 0) : 0);

				let scaleX = (baseWidth > 0 && iframeRect.width > 0) ? iframeRect.width / baseWidth : 1;
				let scaleY = (baseHeight > 0 && iframeRect.height > 0) ? iframeRect.height / baseHeight : 1;

				let screenRect = {
					top: iframeRect.top + iframeRelativeRect.top * scaleY,
					left: iframeRect.left + iframeRelativeRect.left * scaleX,
					width: iframeRelativeRect.width * scaleX,
					height: iframeRelativeRect.height * scaleY
				};

				let containerWidth = this.$el?.offsetWidth || 40;
				let containerHeight = this.$el?.offsetHeight || 60;

				// Кнопка размещается по центру элемента
				let top = screenRect.top + (screenRect.height - containerHeight) / 2;
				let left = screenRect.left + (screenRect.width - containerWidth) / 2;

				this.position.top = `${top}px`;
				this.position.left = `${left}px`;

			},
			// Открываем окно генерации/редактирования ассета для установленного элементу ассета
			replaceElementAsset(screenCodename, elementCodename) {

				let version = Version.SelectedVersion;
				if (!version) return;

				let element = Elements.getImportantElement(screenCodename, elementCodename);
				if (!element) return;

				let sizeKey = Layout.getPreviewSizeKey();
				let assetCodename = element.props?.[sizeKey]?.image;
				if (!assetCodename) return;

				let asset = Asset.getAsset(version, assetCodename);
				if (!asset) return;

				this.hideButton();

				Broadcast.call("Show AssetImageGeneration", [asset]);

			}
		}
	};
</script>

<style lang="sass">

	.asset-replace-container
		position: fixed
		z-index: 100000
		display: flex
		flex-direction: column
		align-items: center
		pointer-events: none

		.asset-replace-btn
			width: 40px
			height: 40px
			display: flex
			align-items: center
			justify-content: center
			//background: rgba(0, 0, 0, 0.5)
			color: #d4af37
			//border: 2px solid #d4af37
			border-radius: 50%
			font-size: 18px
			box-sizing: border-box
			text-shadow: 0 0 15px rgba(0, 0, 0, 0.9), 0 0 15px rgba(0, 0, 0, 0.9), 0 0 15px rgba(0, 0, 0, 0.9), 0 0 15px rgba(0, 0, 0, 0.9), 0 0 15px rgba(0, 0, 0, 0.9)

		.asset-replace-hint
			margin-top: 4px
			padding: 2px 6px
			background: rgba(0, 0, 0, 0.6)
			color: #d4af37
			border-radius: 4px
			font-size: 11px
			white-space: nowrap

</style>
